<template>
    <rkm-modal
        :buttons="['cancel']"
        large
        ref="Modal"
        title="Exames e grupos da coleta"
    >
        <rkm-alert v-if="agendamento" info show>
            <strong>Paciente:</strong> {{ agendamento.paciente }}
            <span v-if="agendamento.data">
                - <strong>Data:</strong> {{ formatDate(agendamento.data) }}
            </span>
            <span v-if="agendamento.horario">
                - <strong>Horário:</strong> {{ agendamento.horario }}
            </span>
        </rkm-alert>

        <rkm-table
            :fields="fields"
            :items="items"
        />
    </rkm-modal>
</template>

<script>
import { formats } from '@/mixins'

export default {
    data: () => ({
        agendamento: null,
        fields: [
            { key: 'descricao', label: 'Exame/Grupo', sortable: true },
        ],
        items: [],
    }),
    methods: {
        open(agendamento) {
            this.agendamento = agendamento
            this.items = this.splitItems(agendamento.examesGrupos)
                .map(descricao => ({ descricao }))
            this.$refs.Modal.show()
        },
        splitItems(value) {
            return value ? value.split('#').filter(Boolean) : []
        },
    },
    mixins: [formats],
}
</script>
